import React from "react";
import { Hidden } from "@material-ui/core";

const DesktopHidden = (props) => {
  return <Hidden only={["xl", "lg", "md"]}>{props.children}</Hidden>;
};
export default DesktopHidden;
